import React from 'react';
import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import { useDroppable } from '@dnd-kit/core';
import Utilities from '@util/Utilities';
import isEmpty from 'lodash/isEmpty';
import Message from '@app/component/message/Message';
import DraggableRoomTag from '@app/site/secured/rateshopper/rates/settings/page/room-mapping/fragment/DraggableRoomTag';
import HotelRoomWithMapping from '@app/model/company_hotel_room_mappings_type_configuration/HotelRoomWithMapping';
import Hotel from '@app/model/hotel/Hotel';


const renderTags = (hotel: Hotel, roomMappings: HotelRoomWithMapping[], type: HotelRoomMappingType, showEmptyMessage: boolean) => {
	const rooms = roomMappings.filter(rm => rm.roomMappingType === type);
	return isEmpty(rooms) ? (showEmptyMessage ? <Message state="info">All Rooms are mapped!</Message> :
		<div />) : rooms.map(rm => <DraggableRoomTag key={rm.roomId} hotelId={hotel.id} roomMapping={rm} />);
};

const MappingTypeDropArea: React.FunctionComponent<{
	hotel: Hotel,
	roomMappings: HotelRoomWithMapping[],
	type: HotelRoomMappingType,
	isHorizontal?: boolean
}> = ({ hotel, roomMappings, type, isHorizontal = false }) => {

	const { setNodeRef, isOver } = useDroppable({
		id: type,
	});


	const className = Utilities.classNames(
		'mt-3 space-y-2 text-gray-800 w-full',
		!isHorizontal ? 'min-h-[350px]' : 'min-h-[60px]',
		isOver ? 'border-dashed border-2 border-blue-300 p-3' : '');

	return <div className={className} ref={setNodeRef}>
		{renderTags(hotel, roomMappings, type, isHorizontal)}
	</div>;
};

export default MappingTypeDropArea;